import * as types from '../constants/prospectConstants.js';


const baseUrl = process.env.REACT_APP_API_URL;

export const createProspect = (prospectData) => async (dispatch) => {
  try {
    dispatch({ type: types.CREATE_PROSPECT_REQUEST });
    
    const formData = new FormData();
    Object.keys(prospectData).forEach(key => {
      formData.append(key, prospectData[key]);
    });

    const response = await fetch(`${baseUrl}/prospects`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();

    if (response.ok) {
      dispatch({
        type: types.CREATE_PROSPECT_SUCCESS,
        payload: data
      });
    } else {
      dispatch({
        type: types.CREATE_PROSPECT_FAILURE,
        payload: data.message || 'Failed to create prospect'
      });
    }
  } catch (error) {
    dispatch({
      type: types.CREATE_PROSPECT_FAILURE,
      payload: error.message
    });
  }
};

export const getProspects = () => async (dispatch) => {
  try {
    dispatch({ type: types.GET_PROSPECTS_REQUEST });
    
    const response = await fetch(`${baseUrl}/prospects`);
    const data = await response.json();

    if (response.ok) {
      dispatch({
        type: types.GET_PROSPECTS_SUCCESS,
        payload: data
      });
    } else {
      dispatch({
        type: types.GET_PROSPECTS_FAILURE,
        payload: data.message || 'Failed to fetch prospects'
      });
    }
  } catch (error) {
    dispatch({
      type: types.GET_PROSPECTS_FAILURE,
      payload: error.message
    });
  }
};

export const clearProspectError = () => ({
  type: types.CLEAR_PROSPECT_ERROR
});